import { render } from "./CoursesDetails.vue?vue&type=template&id=24d0411b&ts=true"
import script from "./CoursesDetails.vue?vue&type=script&lang=ts"
export * from "./CoursesDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__